<template>
  <div>
  
      <!--<div 
        class="
          d-flex
          align-items-center 
          justify-content-end
          content-sidebar-header
          px-2
          py-1
        "
      >
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-toggle.sidebar-right-sourcer
      variant="outline-primary"
      
    >
      Add New Candidate Sourcer
    </b-button>

       
      </div>-->

     
    <b-sidebar
      id="sidebar-right-sourcer"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      right
      backdrop
      shadow
    >
    <div
        class="
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-2
          py-1
        "
      >
        
    <h5>  {{ title }} </h5>
    <textarea id="paste-data" @paste="handlePaste" rows = "1" placeholder="Paste Data here"></textarea>
    <!-- <b-button variant="outline-info" @click="reloadPage">Reload</b-button> -->
    

        
      </div>
        <form v-on:submit.prevent="formSubmitted" enctype="multipart/form-data">
          
          <!-- Full Name -->
          <b-row>
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="First Name *" label-for="first-name">
                  <b-form-input
                    id="first-name"
                    class="text-capitalize"
                    v-model="candidateData.firstName"
                    autofocus
                    ref="firstName"
                    trim
                    placeholder="John"
                  />
                <small v-if="error.firstName" class="text-danger">{{ error.firstName }}</small>
                  
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group label="Last Name *" label-for="last-name">
                  <b-form-input
                    id="last-name"
                    class="text-capitalize"
                    v-model="candidateData.lastName"
                    autofocus
                    trim
                    placeholder="Doe"
                    ref="lastName"
                  />

                <small v-if="error.lastName" class="text-danger">{{ error.lastName }}</small>  
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
             
                <b-form-group label="Company Name *" label-for="companyname">
                  <b-form-input
                    id="company-name"
                    class="text-capitalize"
                    v-model="candidateData.companyName"
                    trim
                    ref="companyName"
                  />
                  <small v-if="error.companyName" class="text-danger">{{ error.companyName }}</small>
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              

              <b-form-group label="Job Title *" label-for="job-title">
                <b-form-input id="job-title" class="text-capitalize" v-model="candidateData.jobTitle" ref="jobTitle" trim />
                <small v-if="error.jobTitle" class="text-danger">{{ error.jobTitle }}</small>
              </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Email -->
              
                <b-form-group :label="emailLabel" label-for="email">
                  
                  <b-form-input
                    id="email"
                    class="text-lowercase"
                    v-model="candidateData.email"
                    trim
                    ref="email"
                    @input="runCheck"
                  />
                  <span v-if="jobInfo.vertical === 'Infra Industry' && jobInfo.category === 'Blue Collar' && jobInfo.type === 'Contractual'" @click="emailNotAvailable" class="text-info">
                    Email Not Available?
                  </span>
                  <small v-if="error.email" class="text-danger">{{ error.email }}</small>   
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
              
              <b-form-group label="Contact *" label-for="contact">
                <b-form-input
                  id="contact"
                  v-model="candidateData.contact"
                  ref="contact"
                  trim
                  @input="runCheck"
                />
                <small v-if="error.contact" class="text-danger">{{ error.contact }}</small>
                <small class="text-primary" @click="checkCandidateExist">{{ checkButton }}</small>
              </b-form-group>
           
          </b-col>
            
            
             <b-col md="6" xl="6" lg="6" sm="6">
              
                <b-form-group :label="ctcLabel" label-for="ctc">
                  <b-form-input
                    id="ctC"
                    v-model="candidateData.ctc"
                    type="number"
                    step=".01"
                    autofocus
                    trim
                    ref="ctc"
                    :placeholder="ctcLabel"
                  />
                  <small v-if="error.ctc" class="text-danger">{{ error.ctc }}</small>
                </b-form-group>
            </b-col>
            <!--<b-col md="6" xl="6" lg="6">
              
              <b-form-group label="Expected CTC *" label-for="expected-ctc">
                <b-form-input
                  id="expected-ctc"
                  type="number"
                  step=".01"
                  v-model="candidateData.expectedCTC"
                  autofocus
                  trim
                  ref="expectedCTC"
                  placeholder="Expected CTC in Lacs"
                />
                <small v-if="!candidateData.expectedCTC" class="text-danger">{{ error.expectedCTC }}</small>
              </b-form-group>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
              
                <b-form-group label="Notice Period *" label-for="notice-period">
                  
                  <v-select
                    id="notice-period"
                    label="value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="candidateData.noticePeriod"
                    ref="noticePeriod"
                    :options="noticePeriodOptions"
                />
                  <small v-if="!candidateData.noticePeriod" class="text-danger">{{ error.noticePeriod }}</small>
                </b-form-group>
            </b-col>-->
            <b-col md="6" xl="6" lg="6">
              
                <b-form-group label="Experience *" label-for="experience">
                  <b-form-input
                    id="experience"
                    v-model="candidateData.exp"
                    type="number"
                    step=".01"
                    trim
                    ref="exp"
                  />           
                  <small v-if="error.exp" class="text-danger">{{ error.exp }}</small>       
                </b-form-group>
              
            </b-col>
            <b-col md="6" xl="6" lg="6">
              
                <b-form-group label="City *" label-for="city">
                  <v-select
                    v-model="candidateData.selectedCity"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="cities"
                    ref="city"
                    :reduce="(option) => option.title"
                  />
                </b-form-group>
                <small v-if="error.selectedCity" class="text-danger">{{ error.selectedCity }}</small>
            </b-col>
            <!--<b-col md="6" xl="6" lg="6">
              
                <b-form-group label="Preferred Location *" label-for="pre-city">
                  <v-select
                    v-model="candidateData.preferredCities"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="cities"
                    :close-on-select="false"
                    multiple
                    ref="preCity"
                  />
                </b-form-group>
                <small v-if="!candidateData.preferredCities" class="text-danger">{{ error.preferredCities }}</small>
            </b-col> -->
            <b-col md="6" xl="6" lg="6">
              
                <b-form-group
                  label="Skills *"
                  label-for="skills"
                >
                 
                  <!-- <v-select
                    v-model="candidateData.skillsSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="skillsOptions"
                    :close-on-select="false"
                    multiple
                    ref="skills"
                  /> -->
                  <b-form-input
                    v-model="candidateData.skillsSelected"
                    placeholder="Skill Selected"
                    type="text"
                    ref="select-skill"
                    id="select-skill"
                    :disabled="true"
                    trim
                  />
                  <small v-if="error.skillsSelected" class="text-danger">{{ error.skillsSelected }}</small>
                </b-form-group>
            </b-col>

            <b-col md="6" xl="6" lg="6">
              <b-form-group label="Qualification *" label-for="qualification">
                <v-select
                  id="qual"
                  v-model="candidateData.qualification"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="qualifications"
                  label="title"
                  required
                  ref="qualification"
                  :reduce="(option) => option.title"
                />
              </b-form-group>
              <small v-if="error.qualification" class="text-danger">{{ error.qualification }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6"> 
              

              <b-form-group label="Source *" label-for="source">
                <v-select
                  v-model="candidateData.source"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sources"
                  input-id="source"
                  label="title"
                  required
                  ref="source"
                  
                />
                <!-- @input="checkIfLinkedIn" -->
              </b-form-group>
              <small v-if="error.source" class="text-danger">{{ error.source }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
                <b-form-group
                  v-if="jobInfo.type === 'Contractual'"
                  label="DOB *"
                  label-for="dob"
                >
                  
                  <flat-pickr
                    class="form-control"
                    id="dob" 
                    v-model="candidateData.dob" 
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
                <b-form-group
                  v-if="jobInfo.type !== 'Contractual'"
                  label="DOB"
                  label-for="dob"
                >
                  
                  <flat-pickr
                    class="form-control"
                    id="dob" 
                    v-model="candidateData.dob" 
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
                <!-- <small class="text-danger" v-if="candidateData.dob && jobInfo.type === 'Contractual' && calculateAge(candidateData.dob) < 18">Under Age Alert!!! Please do not add these candidate</small> -->
                <!-- <small v-if="!candidateData.dob && jobInfo.type === 'Contractual'" class="text-danger">{{ error.dob }}</small> -->
            </b-col>
            <b-col md="6" xl="6" lg="6">
              

              <b-form-group label="Gender *" label-for="gender">
                <v-select
                  v-model="candidateData.genderSelected"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="genderOptions"
                  input-id="gender"
                  label="title"
                  required
                  ref="gender"
                  :reduce="(option) => option.title"
                />
              </b-form-group>
              <small v-if="error.gender" class="text-danger">{{ error.gender }}</small>
            </b-col>
            <b-col md="6" xl="6" lg="6">
              <!-- Plan -->
              <b-form-group label="Upload Resume *" label-for="resume">
                <b-form-file
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  id="cv-file"
                  name="cv-file"
                  accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, text/plain, application/rtf, text/markdown"
                  @change="openFile"
                  v-model="candidateData.file"
                  type="file"
                  ref="file"
                  :disabled="submitDisabled"
                />
              </b-form-group>
              <span v-if="jobInfo.vertical === 'Infra Industry' && jobInfo.category === 'Blue Collar' && jobInfo.type === 'Contractual'" @click="cvNotAvailable" class="text-info">
                CV Not Available?
              </span>
              <small v-if="error.file" class="text-danger">{{ error.file }}</small>
              <small v-if="file && file.size > 1690000" class="text-danger"> File Size Should be less than 1.5 mb </small>
              
            </b-col>
            <!-- <b-col md="6" xl="6" lg="6">
              
              <b-form-group label="Remarks" label-for="remarks">
                <b-form-textarea
                  id="textarea-default"
                  placeholder="Add Remark"
                  rows="3"
                  v-model="candidateData.remarks"
                />
              </b-form-group>
            </b-col> -->
          </b-row>
          <span class="text-danger" v-if="apiError">{{ apiError }}</span>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              :disabled="submitDisabled"
              class="mr-2"
              type="submit"
              value="submit"
              id="submit"
              
            >
              <span v-if="!loading">Add</span>
              
              
              <b-spinner small v-else-if="loading"/>
            </b-button>
            <!--<b-button
              variant="primary"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              <span class="sr-only">Loading...</span>
            </b-button>-->
            <b-button @click="closeToggle">
              Cancel
            </b-button>
          </div>
        </form>
        </b-sidebar>
    <!--</template>
  </b-sidebar>-->
  </div>
</template>

<script>
import {

  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BSpinner,
  BRow,
  BCol,
  BFormDatepicker,
  BFormFile,
  BFormTextarea,
  BButton, BSidebar, VBToggle
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref } from "vue";
import { required, alphaNum, email } from "@validations";
//import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from 'vue-ripple-directive'
import vSelect from "vue-select";
import countries from "@/@fake-db/data/other/countries";
//import store from "@/store";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CandidateService from '@/services/candidate-service'
import JobService from '@/services/job-service'
import jobTimelineService from '@/services/job-timeline'
import flatPickr from 'vue-flatpickr-component'
import locationService from "@/services/location-service";
import adminConfigService from "@/services/admin-config-service";
import jobService from '../../../../services/job-service';
// import emailTemplates from "@/services/email-templates";
// import mailService from "@/services/mail-service"
// import firebaseMessaging from '@/firebase'
// import UserService from "@/services/user-service";

export default {
  components: {
    BSidebar, BButton, VBToggle,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BSpinner,
    vSelect,
    BRow,
    BCol,
    BFormDatepicker,
    BFormFile,
    BFormTextarea,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  /*model: {
    prop: "isAddNewCandidateSidebarActive",
    event: "update:is-add-new-candidate-sidebar-active",
  },
  props: {
    isAddNewCandidateSidebarActive: {
      type: Boolean|String,
      required: true,
    },
    isEventHandlerSidebarActive: {
      type: Boolean,
      required: true,
    },
    /*roleOptions: {
      type: Array,
      required: true,
    },
    planOptions: {
      type: Array,
      required: true,
    },
  },*/
  props: {
    jobInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      title: 'Add New Candidate',
      required,
      alphaNum,
      email,
      countries,
      selectedCity: { title: "Pune" },
      preferredCities: '',
      // jobInfo: {},
      // jobInfo: {},
      //selectedState: { title: "Maharashtra" },
      cities: [{"title":"Mumbai"},{"title":"Delhi"},{"title":"Bangalore"},{"title":"Hyderabad"},{"title":"Pune"},{"title":"Ahmedabad"},{"title":"Chennai"},{"title":"Kolkata"},{"title":"Surat"},{"title":"Jaipur"},{"title":"Lucknow"},{"title":"Kanpur"},{"title":"Nagpur"},{"title":"Indore"},{"title":"Thane"},{"title":"Bhopal"},{"title":"Visakhapatnam"},{"title":"Pimpri and Chinchwad"},{"title":"Patna"},{"title":"Vadodara"},{"title":"Ghaziabad"},{"title":"Ludhiana"},{"title":"Agra"},{"title":"Nashik"},{"title":"Faridabad"},{"title":"Meerut"},{"title":"Rajkot"},{"title":"Kalyan and Dombivali"},{"title":"Vasai Virar"},{"title":"Varanasi"},{"title":"Srinagar"},{"title":"Aurangabad"},{"title":"Dhanbad"},{"title":"Amritsar"},{"title":"Navi Mumbai"},{"title":"Allahabad"},{"title":"Haora"},{"title":"Ranchi"},{"title":"Gwalior"},{"title":"Jabalpur"},{"title":"Coimbatore"},{"title":"Vijayawada"},{"title":"Jodhpur"},{"title":"Madurai"},{"title":"Raipur"},{"title":"Kota"},{"title":"Chandigarh"},{"title":"Guwahati"},{"title":"Solapur"},{"title":"Hubli and Dharwad"},{"title":"Bareilly"},{"title":"Mysore"},{"title":"Moradabad"},{"title":"Gurgaon"},{"title":"Aligarh"},{"title":"Jalandhar"},{"title":"Tiruchirappalli"},{"title":"Bhubaneswar"},{"title":"Salem"},{"title":"Mira and Bhayander"},{"title":"Thiruvananthapuram"},{"title":"Bhiwandi"},{"title":"Saharanpur"},{"title":"Gorakhpur"},{"title":"Guntur"},{"title":"Amravati"},{"title":"Bikaner"},{"title":"Noida"},{"title":"Jamshedpur"},{"title":"Bhilai Nagar"},{"title":"Warangal"},{"title":"Cuttack"},{"title":"Firozabad"},{"title":"Kochi"},{"title":"Bhavnagar"},{"title":"Dehradun"},{"title":"Durgapur"},{"title":"Asansol"},{"title":"Nanded Waghala"},{"title":"Kolapur"},{"title":"Ajmer"},{"title":"Gulbarga"},{"title":"Loni"},{"title":"Ujjain"},{"title":"Siliguri"},{"title":"Ulhasnagar"},{"title":"Jhansi"},{"title":"Sangli Miraj Kupwad"},{"title":"Jammu"},{"title":"Nellore"},{"title":"Mangalore"},{"title":"Belgaum"},{"title":"Jamnagar"},{"title":"Tirunelveli"},{"title":"Malegaon"},{"title":"Gaya"},{"title":"Ambattur"},{"title":"Jalgaon"},{"title":"Udaipur"},{"title":"Maheshtala"},{"title":"Tiruppur"},{"title":"Davanagere"},{"title":"Kozhikode"},{"title":"Kurnool"},{"title":"Akola"},{"title":"Rajpur Sonarpur"},{"title":"Bokaro Steel"},{"title":"Bellary"},{"title":"Patiala"},{"title":"South Dum Dum"},{"title":"Rajarhat Gopalpur"},{"title":"Bhagalpur"},{"title":"Agartala"},{"title":"Muzaffarnagar"},{"title":"Bhatpara"},{"title":"Latur"},{"title":"Panihati"},{"title":"Dhule"},{"title":"Rohtak"},{"title":"Korba"},{"title":"Bhilwara"},{"title":"Brahmapur Town"},{"title":"Muzaffarpur"},{"title":"Ahmadnagar"},{"title":"Mathura"},{"title":"Kollam"},{"title":"Avadi"},{"title":"Kadapa"},{"title":"Rajahmundry"},{"title":"Bilaspur"},{"title":"Kamarhati"},{"title":"Shahjahanpur"},{"title":"Bijapur"},{"title":"Rampur"},{"title":"Shimoga"},{"title":"Chandrapur"},{"title":"Junagadh"},{"title":"Thrissur"},{"title":"Alwar"},{"title":"Barddhaman"},{"title":"Kulti"},{"title":"Kakinada"},{"title":"Nizamabad"},{"title":"Parbhani"},{"title":"Tumkur"},{"title":"Hisar"},{"title":"Ozhukarai"},{"title":"Biharsharif"},{"title":"Darbhanga"},{"title":"Panipat"},{"title":"Aizawl"},{"title":"Bally"},{"title":"Dewas"},{"title":"Tirupati"},{"title":"Ichalkaranji"},{"title":"Karnal"},{"title":"Bathinda"},{"title":"Jalna"},{"title":"Kirari Suleman Nagar"},{"title":"Purnia"},{"title":"Satna"},{"title":"Maunath Bhanjan"},{"title":"Barasat"},{"title":"Sonipat"},{"title":"Farrukhabad and Fatehgarh"},{"title":"Sagar"},{"title":"Raurkela"},{"title":"Durg"},{"title":"Imphal"},{"title":"Ratlam"},{"title":"Hapur"},{"title":"Arrah"},{"title":"Karimnagar"},{"title":"Anantapur"},{"title":"NDMC"},{"title":"Etawah"},{"title":"Ambernath"},{"title":"Bharatpur"},{"title":"Begusarai"},{"title":"Tiruvottiyur"},{"title":"North Dum Dum"},{"title":"Gandhidham"},{"title":"Baranagar"},{"title":"Puducherry"},{"title":"Thoothukkudi"},{"title":"Sikar"},{"title":"Rewa"},{"title":"Mirzapur and Vindhyachal"},{"title":"Raichur"},{"title":"Pali"},{"title":"Ramagundam"},{"title":"Hardwar"},{"title":"Vizianagaram"},{"title":"Katihar"},{"title":"Nagercoil"},{"title":"Ganganagar"},{"title":"Karawal Nagar"},{"title":"Mango"},{"title":"Thanjavur"},{"title":"Bulandshahr"},{"title":"Uluberia"},{"title":"Murwara"},{"title":"Sambhal"},{"title":"Singrauli"},{"title":"Nadiad"},{"title":"Secunderabad"},{"title":"Naihati"},{"title":"Yamunanagar"},{"title":"Bidhan Nagar"},{"title":"Pallavaram"},{"title":"Bidar"},{"title":"Munger"},{"title":"Panchkula"},{"title":"Burhanpur"},{"title":"Raurkela Industrial Township"},{"title":"Kharagpur"},{"title":"Dindigul"},{"title":"Hospet"},{"title":"Gandhinagar"},{"title":"Nangloi Jat"},{"title":"English Bazar"},{"title":"Ongole"},{"title":"Eluru"},{"title":"Deoghar"},{"title":"Chapra"},{"title":"Haldia"},{"title":"Khandwa"},{"title":"Puri Town"},{"title":"Nandyal"},{"title":"Morena"},{"title":"Amroha"},{"title":"Anand"},{"title":"Bhind"},{"title":"Bhalswa Jahangir Pur"},{"title":"Madhyamgram"},{"title":"Bhiwani"},{"title":"Navi Mumbai Panvel Raigad"},{"title":"Baharampur"},{"title":"Ambala"},{"title":"Morvi"},{"title":"Fatehpur"},{"title":"Rae Bareli"},{"title":"Khora"},{"title":"Bhusawal"},{"title":"Orai"},{"title":"Bahraich"},{"title":"Vellore"},{"title":"Mahesana"},{"title":"Khammam"},{"title":"Sambalpur"},{"title":"Raiganj"},{"title":"Sirsa"},{"title":"Dinapur Nizamat"},{"title":"Serampore"},{"title":"Sultan Pur Majra"},{"title":"Guna"},{"title":"Jaunpur"},{"title":"Panvel"},{"title":"Shivpuri"},{"title":"Surendranagar Dudhrej"},{"title":"Unnao"},{"title":"Hugli and Chinsurah"},{"title":"Sitapur"},{"title":"Hastsal"},{"title":"Tambaram"},{"title":"Adityapur"},{"title":"Badalapur"},{"title":"Alappuzha"},{"title":"Cuddalore"},{"title":"Silchar"},{"title":"Gadag and Betigeri"},{"title":"Bahadurgarh"},{"title":"Machilipatnam"},{"title":"Shimla"},{"title":"Medinipur"},{"title":"Deoli"},{"title":"Bharuch"},{"title":"Hoshiarpur"},{"title":"Jind"},{"title":"Chandannagar"},{"title":"Adoni"},{"title":"Tonk"},{"title":"Faizabad"},{"title":"Tenali"},{"title":"Alandur"},{"title":"Kancheepuram"},{"title":"Vapi"},{"title":"Rajnandgaon"},{"title":"Proddatur"},{"title":"Navsari"},{"title":"Budaun"},{"title":"Uttarpara Kotrung"},{"title":"Mahbubnagar"},{"title":"Erode"},{"title":"Batala"},
      {"title":"Saharsa"},{"title":"Haldwani and Kathgodam"},{"title":"Vidisha"},{"title":"Thanesar"},{"title":"Kishangarh"},{"title":"Dallo Pura"},{"title":"Veraval"},{"title":"Banda"},{"title":"Chittoor"},{"title":"Krishnanagar"},{"title":"Barrackpur"},{"title":"Lakhimpur"},{"title":"Santipur"},{"title":"Porbandar"},{"title":"Hindupur"},{"title":"Balurghat"},{"title":"Bhadravati"},{"title":"Hanumangarh"},{"title":"Moga"},{"title":"Pathankot"},{"title":"Hajipur"},{"title":"Sasaram"},{"title":"Habra"},{"title":"Bid"},{"title":"Mohali"},{"title":"Burari"},{"title":"Beawar"},{"title":"Abohar"},{"title":"Tiruvannamalai"},{"title":"Jamuria"},{"title":"Kaithal"},{"title":"Godhra"},{"title":"Bhuj"},{"title":"Robertson Pet"},{"title":"Shillong"},{"title":"Rewari"},{"title":"Hazaribag"},{"title":"Bhimavaram"},{"title":"Mandsaur"},{"title":"Chas"},{"title":"Rudrapur"},{"title":"Chitradurga"},{"title":"Kumbakonam"},{"title":"Dibrugarh"},{"title":"Kolar"},{"title":"Chhindwara"},{"title":"Bankura"},{"title":"Mandya"},{"title":"Dehri"},{"title":"Raigarh"},{"title":"Madanapalle"},{"title":"Nalgonda"},{"title":"Hathras"},{"title":"Malerkotla"},{"title":"Siwan"},{"title":"Chhattarpur"},{"title":"Hassan"},{"title":"Lalitpur"},{"title":"Gondiya"},{"title":"North Barrackpur"},{"title":"Bettiah"},{"title":"Palakkad"},{"title":"Rajapalayam"},{"title":"Botad"},{"title":"Modinagar"},{"title":"Deoria"},{"title":"Raniganj"},{"title":"Palwal"},{"title":"Khanna"},{"title":"Neemuch"},{"title":"Pilibhit"},{"title":"Mustafabad"},{"title":"Hardoi"},{"title":"Guntakal"},{"title":"Pithampur"},{"title":"Motihari"},{"title":"Dhaulpur"},{"title":"Srikakulam"},{"title":"Nabadwip"},{"title":"Patan"},{"title":"Jagdalpur"},{"title":"Udupi"},{"title":"Basirhat"},{"title":"Damoh"},{"title":"Halisahar"},{"title":"Jagadhri"},{"title":"Rishra"},{"title":"Kurichi"},{"title":"Dimapur"},{"title":"Palanpur"},{"title":"Dharmavaram"},{"title":"Gokal Pur"},{"title":"Kashipur"},{"title":"Ashokenagar Kalyangarh"},{"title":"Baidyabati"},{"title":"Sawai Madhopur"},{"title":"Puruliya"},{"title":"Mandoli"},{"title":"Mainpuri"},{"title":"Kanchrapara"},{"title":"Satara"},{"title":"Churu"},{"title":"Madavaram"},{"title":"Gangapur"},{"title":"Dabgram"},{"title":"Darjiling"},{"title":"Barshi"},{"title":"Etah"},{"title":"Jhunjhunun"},{"title":"Chikmagalur"},{"title":"Jetpur Navagadh"},{"title":"Roorkee"},{"title":"Gudivada"},{"title":"Baleshwar"},{"title":"Baran"},{"title":"Hoshangabad"},{"title":"Nagaon"},{"title":"Pudukkottai"},{"title":"Adilabad"},{"title":"Hosur"},{"title":"Muktsar"},{"title":"Yavatmal"},{"title":"Titagarh"},{"title":"Barnala"},{"title":"Chittaurgarh"},{"title":"Narasaraopet"},{"title":"Dum Dum"},{"title":"Basti"},{"title":"Valsad"},{"title":"Ambur"},{"title":"Giridih"},{"title":"Chandausi"},{"title":"Gonda"},{"title":"Bally Town"},{"title":"Kalol"},{"title":"Bagaha"},{"title":"Ambikapur"},{"title":"Achalpur"},{"title":"Gondal"},{"title":"Bagalkot"},{"title":"Osmanabad"},{"title":"Akbarpur"},{"title":"Champdani"},{"title":"Deesa"},{"title":"Khurja"},{"title":"Nandurbar"},{"title":"Azamgarh"},{"title":"Ghazipur"},{"title":"Delhi Cantonment"},{"title":"Firozpur"},{"title":"Baripada"},{"title":"Mughalsarai"},{"title":"Anantnag"},{"title":"Sehore"},{"title":"Bongaon"},{"title":"Kanpur Cantonment"},{"title":"Khardaha"},{"title":"Tadpatri"},{"title":"Port Blair"},{"title":"Sultanpur"},{"title":"Bhadrak"},{"title":"Shikohabad"},{"title":"Jalpaiguri"},{"title":"Shamli"},{"title":"Karaikkudi"},{"title":"Khargone"},{"title":"Wardha"},{"title":"Ranibennur"},{"title":"Kishanganj"},{"title":"Neyveli"},{"title":"Amreli"},{"title":"Suryapet"},{"title":"Gangawati"},{"title":"Hindaun"},{"title":"Jamalpur"},{"title":"Bhiwadi"},{"title":"Ballia"},{"title":"Bansberia"},{"title":"Tadepalligudem"},{"title":"Miryalaguda"},{"title":"Baraut"},{"title":"Udgir"},{"title":"Betul"},{"title":"Bundi"},{"title":"Jehanabad"},{"title":"Ambala Sadar"},{"title":"Nagapattinam"},{"title":"Nagaur"},{"title":"Buxar"},{"title":"Seoni"},{"title":"Greater Noida"},{"title":"Hinganghat"},{"title":"Sujangarh"},{"title":"Bhadreswar"},{"title":"Chilakaluripet"},{"title":"Kasganj"},{"title":"Kalyani"},{"title":"Gangtok"},{"title":"Datia"},{"title":"Nagda"},{"title":"Banswara"},{"title":"Kapurthala"}, {"title": "Remote"}, {"title": "PAN INDIA"}, {"title": "Ratnagiri"}, {"title": "Goa"}, {"title": "Panaji"}],
      //response: 'hi there',
      //jobInfo: this.jobInfo,
      jId: '',
      // genderOptions: [
      //   { title: "Male" },
      //   { title: "Female" },
      //   { title: "Transgender" },
      //   { title: "Non-binary/non-conforming" },
      //   { title: "Prefer not to respond" },
      // ],
      genderOptions: [
        { title: "Male" },
        { title: "Female" },
        { title: "LGBQ" },
        { title: "Transgender" },
      ],
      qualifications: [],
      /*specialization: [{ title: "Agriculture" }, 
        { title: "Automobile" }, 
        { title: "Aviation" }, 
        { title: "Bio-Chemistry/Bio-Technology" }, 
        { title: "Biomedical" }, 
        { title: "Ceramics" }, 
        { title: "Chemical" }, 
        { title: "Civil" }, 
        { title: "Computers" }, 
        { title: "Electrical" }, 
        { title: "Electronics/Telecommunication" }, 
        { title: "Energy" }, 
        { title: "Environmental" }, 
        { title: "Instrumentation" }, 
        { title: "Marine" }, 
        { title: "Mechanical" }, 
        { title: "Metallurgy" }, 
        { title: "Mineral" }, 
        { title: "Mining" }, 
        { title: "Nuclear" }, 
        { title: "Paint/Oil" }, 
        { title: "Petroleum" }, 
        { title: "Plastics" }, 
        { title: "Production/Industrial" }, 
        { title: "Textile" }, 
        { title: "OtherSpecialization" }],*/
      sources: [],
      /*noticePeriodOptions: [
        { value: 'Immediate', text: 0 },
        { value: 15, text: 15 },
        { value: 30, text: 30 },
        { value: 45, text: 45 },
        { value: 60, text: 60 },
        { value: 90, text: 90 },
      ],*/
      candidateData: {
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        contact: "",
        jobTitle: "",
        selectedCity: "",
        ctc: null,
        // expectedCTC: "",
        exp: null,
        noticePeriod: null,
        skillsSelected: "",
        source: "",
        qualification: "",
        // dob: "",
        genderSelected: "",
        file: null,
        // remarks: ""
    },
    isAddNewCandidateSidebarActive: false,
    error: {
      firstName: '',
      lastName: '',
      email: '',
      contact: '',
      exp: '',
      selectedCity: '',
      skillsSelected: '',
      qualification: '',
      source: '',
      genderSelected: '',
      companyName: '',
      jobTitle: '',
      ctc: '',
      // expectedCTC: '',
      // noticePeriod: '',
      file:''
    },
    cvFile: true,
    skillsOptions: [],
    loading: false,
    enabled: false,
    file: null,
    checkButton: 'Check if Exist',
    ctcLabel: 'CTC',
    emailLabel: 'Email *',
    jobId: null,
    apiError: null,
    submitDisabled: false,
    // underAge: false
    };
  },
  watch: {
    file: function(newFileSize) {
        this.handleFileSize(this.file.size)
    }
  },
  created() {
  },
  beforeMount() {
    console.log('job info: ', this.jobInfo)
    if (this.jobInfo) {
      this.candidateData.skillsSelected = this.jobInfo.position_name;
      // this.formData.email = this.candidateData.email;
      // initialize other form fields...
    }
    // if(this.jobInfo) {
    //   this.jId = this.jobInfo.id
    // }
    console.log('jobInfo: ', this.jobInfo)
    if(this.jobInfo.vertical === 'Infra Industry' && this.jobInfo.category === 'Blue Collar' && this.jobInfo.type === 'Contractual') {
      this.ctcLabel = 'Salary per month *'
    }
  },
  methods: {
    handlePaste(e) {
      console.log('handle paste', e)
      if(this.candidateData.skillsSelected === '' || !this.candidateData.skillsSelected) {
        this.candidateData.skillsSelected = this.jobInfo.position_name
        console.log('in updated skill selected', this.candidateData.skillsSelected, this.jobInfo.position_name);
      } 
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('Text');
      console.log('paste data: ', clipboardData, pastedData)
      try {
        const jsonData = JSON.parse(pastedData);
        
        for (const key in jsonData) {
          if (this.candidateData.hasOwnProperty(key) && key !== 'file') {
            this.candidateData[key] = jsonData[key];
          }
        }
        // this.candidateData.selectedCity = jsonData.selectedCity
        // this.candidateData.qualification = jsonData.qualification
        this.candidateData.lastName = jsonData.LastName ? jsonData.LastName : '.'
        console.log(jsonData.dob)
        this.candidateData.dob = jsonData.dob ? this.formatDate(jsonData.dob) : null
        e.clipboardData = null
        window.clipboardData = null
        setTimeout( () => {
          console.log('running checck in 100 millisecond to check if candidate exist')
          this.runCheck()
        },500)
      } catch (error) {
        this.runCheck()
        console.error('Failed to parse JSON data:', error);
        // Handle error for invalid JSON data
      }
    },
    removePasteData(e) {

    },
    openFile(event) {
      this.file = event.target.files[0];
      //console.log("file", this.file);
      //console.log("cfile", this.candidateData.file)
    },
    handleFileSize() {
      // const validation = this.validationForm();
      // if(!validation) {
      //   this.submitDisabled = true
      // } else {
      //   this.submitDisabled = false
      // }
      this.apiError = null
      console.log('inside handle file size')
      if (this.file.size > 1690000) {
        this.apiError = "File size should not be greater than 1.5 MB"
        console.log('inside handle file size submit disabled')
        this.submitDisabled = true
      } else {
        this.apiError = null
        console.log('inside handle file size submit enabled')
        this.submitDisabled = false
      }
    },
    formSubmitted() {
      this.submitDisabled = false
      this.apiError = null
      //this.$router.push({ name: 'search', query: { q: this.query } });
      this.loading = true
      //console.log(this.candidateData)
      const validation = this.validationForm();
      console.log(validation)
      // if(!validation) {
      //   this.submitDisabled = true
      // }
      if(validation) {
        const source = String(this.candidateData.source['title'])
        const userData = JSON.parse(localStorage.getItem('userData'));
        const user = `[{"title" : "${userData.first_name} ${userData.last_name}", "emp_id": "${userData.emp_id}"}]`
        const username = `${userData.first_name} ${userData.last_name}`
        const skills = this.candidateData.skillsSelected
        //const city = String(this.candidateData.selectedCity['title']) ? String(this.candidateData.selectedCity['title']) : this.candidateData.selectedCity
        //const qualification = String(this.candidateData.qualification['title']) ? String(this.candidateData.qualification['title']) : this.candidateData.qualification
        //const gender = String(this.candidateData.genderSelected['title']) ? String(this.candidateData.genderSelected['title']) : this.candidateData.genderSelected
        console.log("gender selected: ", this.candidateData.genderSelected)
        const formData = new FormData()
        formData.append('first_name', this.candidateData.firstName)
        formData.append('last_name', this.candidateData.lastName)
        formData.append('email', this.candidateData.email.toLowerCase())
        formData.append('contact_no', this.candidateData.contact)
        formData.append('curr_company', this.candidateData.companyName)
        formData.append('curr_position', this.candidateData.jobTitle)
        formData.append('curr_location', this.candidateData.selectedCity)
        formData.append('ctc', isNaN(parseFloat(this.candidateData.ctc)) ? null : parseFloat(this.candidateData.ctc))
        formData.append('exp', isNaN(parseFloat(this.candidateData.exp)) ? null : parseFloat(this.candidateData.exp))
        formData.append('skills', skills)
        formData.append('source', source)
        formData.append('status', 'UploadedBySourcer')
        formData.append('created_by', user)
        formData.append('updated_by', user)
        formData.append('qualification', this.candidateData.qualification)
        formData.append('dob', this.candidateData.dob ? this.candidateData.dob : "1900-01-01")
        formData.append('gender', this.candidateData.genderSelected)
        //formData.append('sourcer', userData.emp_id)
        formData.append('cvFile', this.candidateData.file)
        
        //console.log(formData)
        CandidateService.addCandidate(formData).then(res => {
          if(!res) {
            this.apiError = 'Failed to add candidate. Please Contact IT Team.'
            this.loading = false
          }
          console.log(res.status) 
          
          if(res.status === "OK") {
            
            if(this.jobId) {
              
              //console.log("position", res.data.curr_position)
              const candidate_id = res.data.candidate_id
              const cid = res.data.id
              const candidate_name = `${res.data.first_name} ${res.data.last_name}`
              
              const c = [];
              c.push(cid)
              
              const data = {
                job_id: this.jobId,
                candidate_id: c,
                candidateStatus: 'UploadedBySourcer',
                source: res.data.source,
                addedBy: user,
                updatedBy: user,
                sourcer: userData.emp_id,
              }
              //console.log(data)
              JobService.assignCandidateToJob(data).then(res => {
                if(res.status === "OK") {
                  const timelineData = {
                    title: `${candidate_id} - New Candidate - ${candidate_name} added`,
                    description: `New Candidate - Sourcer - CS-Changed`,
                    type: "info",
                    createdBy: username,
                    jobId: this.jobId,
                    candidate_id: cid,
                    candidateStatus: data.candidateStatus,
                  }
                  //console.log(timelineData);
                
                  jobTimelineService.create(timelineData).then(res => {
                    //console.log("timeline", res)
                    
                    //console.log( "client name", this.jobInfo.client[0].title )
                    
                  })
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Candidate Added to the Job Successfully',
                      icon: 'EditIcon',
                      variant: 'success',
                      timeout: 2000,
                    },
                  })
                  
                  //this.$router.push({ path: '/apps/view-job/' + data.job_id }).catch(() => {})
                  this.loading = false
                  this.$emit('refreshParent', true)
                  this.resetData()
                  console.log('job data after add', this.jobInfo)
                  this.$root.$emit('bv::toggle::collapse', 'sidebar-right-sourcer')
                  console.log('jobInfo: ', this.jobInfo)
                  this.candidateData.skillsSelected = this.jobInfo.position_name
                  if(this.jobInfo.vertical === 'Infra Industry' && this.jobInfo.category === 'Blue Collar' && this.jobInfo.type === 'Contractual') {
                    this.ctcLabel = 'Salary per month *'
                  }
                  console.log('job data after toggle close', this.jobInfo)
                  // window.location.reload();
                } else if (res.status === 403) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Not Authourized to add candidate !!!',
                      icon: 'EditIcon',
                      variant: 'danger',
                      timeout: 5000,
                    },
                  })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Candidate Add to Job Failed !!!',
                      icon: 'EditIcon',
                      variant: 'danger',
                      timeout: 5000,
                    },
                  })
                  this.loading = false
                  //this.$router.push({ path: '/apps/view-job/' + data.job_id }).catch(() => {})
                  this.$emit('refreshParent', true)
                  this.resetData()
                  this.candidateData.skillsSelected = this.jobInfo.position_name
                  this.$root.$emit('bv::toggle::collapse', 'sidebar-right-sourcer')

                  //window.location.reload();
                }
              })
            }
            else{
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Candidate Added Successfully',
                  icon: 'EditIcon',
                  variant: 'success',
                  timeout: 5000,
                },
              })
              this.$emit('refreshParent', true)
              // window.location.reload();
              
              this.resetData()
              this.$root.$emit('bv::toggle::collapse', 'sidebar-right-sourcer')
              
            }
            //this.$router.push({ name: 'apps-candidates-list-all'}).catch(() => {})
            //return res.data          
          } else if ((res.status === 400 ) ) {
            this.apiError = res.data.error
            this.loading = false
          }
          else if ((res.status === 401 ) || (res.status === 403 )) {
            this.loading = false
            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
            localStorage.clear();
            this.$router.push({ name: "auth-login" });
          } else if (res.status === 413 || res.statusText === 'Request Entity Too Large') {
            this.loading = false
            this.error.file = 'File Size Too Large! Kindly compress and reupload'
          } else if (res.status === 502) {
            this.loading = false
            this.apiError = 'Aargh!! looks like something is not right, Please wait for 1 minute and try clicking add again.'
          }
          else if (res.status === 500 ) {
            this.loading = false
            //console.log(res.data)
            if(JSON.stringify(res.data).includes('Validation error')) {

              //console.log(res.data.error, res.data.error.errors[0])  
              let msg = res.data.error.errors[0].message
              //console.log(msg)
              this.loading = false
              const msg1 = "To assign this Candidate in this Job, click on Assign Candidates Tab, search the Candidate and on right hand side click on three dots for the searched candidate and click on Assign to This Job"
              if(msg === "email must be unique") {
                msg = "Email already exists!"
                this.error.email = "Duplicate! Email Already exists!" + msg1
              } else if (msg === "contact_no must be unique") {
                msg = "Contact No already exists!"
                this.error.contact = "Duplicate! Contact No Already exists!" + msg1
              } else {
                this.error.file = msg
              }  

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Candidate Add Failed ' + msg,
                  icon: 'EditIcon',
                  variant: 'danger',
                  timeout: 5000,
                },
              })
              //this.$router.push({ name: 'apps-candidates-list-all'}).catch(() => {})
              //this.$emit('refreshParent', true)
                //window.location.reload();
                //this.resetData()
                //this.$root.$emit('bv::toggle::collapse', 'sidebar-right-sourcer')
              //window.location.reload();
              return msg
            } else if (JSON.stringify(res.data).includes('File too large')){
              this.error.file = 'File Size Too Large! Kindly compress and reupload'
            } else if(res.status === 'FAILED'){
              this.apiError = res.data.message
            } else {
              this.apiError = res.data.message + ' Please Contact IT Admin'
            }
          } else if(res.status === 'FAILED') {
            this.apiError = res.data.message
          } else {
            this.apiError = res.data.message
          }
        })
      }
    },
    // reloadPage() {
    //   window.location.reload();
    // },
    validateEmail(email){
      return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    checkCandidateExist() {
      this.submitDisabled = false
      // console.log('check valid mobile number', this.isValidMobileNumber(), this.candidateData.contact)
      if(this.candidateData.email && this.candidateData.contact && this.isValidMobileNumber(this.candidateData.contact)) {
        if(this.validateEmail(this.candidateData.email) && this.candidateData.contact.length === 10) {
          console.log('email & contact validated')
          CandidateService.checkCandidateExist(this.candidateData.email, this.candidateData.contact).then(res => {
            console.log(res)
             if(res.status === "OK") {
                this.error.email = 'Candidate Already Exist in ATS'
                this.error.contact = null
                this.checkButton = null
                this.submitDisabled = true
                
             } else if (res.status === 400) {
                this.checkButton = 'Fresh Candidate'
                this.error.email = null
                this.error.contact = null
             }
          })
        } else {
          this.error.email = 'Please enter valid email'
          this.error.contact = 'Please enter valid contact number 10 digit'
        }
      } else if (!this.candidateData.email || !this.candidateData.contact || !this.isValidMobileNumber(this.candidateData.contact)) {
        if (!this.candidateData.email || !this.validateEmail(this.candidateData.email)) {
          this.error.email = 'Please enter valid email'
          this.checkButton = 'Check if exist'
        }
        if (!this.candidateData.contact || !this.candidateData.contact.length !== 10 || !this.isValidMobileNumber(this.candidateData.contact)) {
          this.error.contact = 'Please enter valid contact no(10 digits required)'
          this.checkButton = 'Check if exist'
          this.submitDisabled = true
        }
      } 
    },
    runCheck() {
      console.log('in check')
      this.checkCandidateExist()
    },
    // checkIfLinkedIn() {
    //   const source = String(this.candidateData.source['title'])
    //   if(source === 'LinkedIn') {
    //     console.log('CTC is not mandatory in case of source: LinkedIn')
    //     this.ctcLabel = 'CTC'
    //   } else {
    //     this.ctcLabel = 'CTC *'
    //   }
    // },
    closeToggle() {
      //console.log("called")
      this.loading = false
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right-sourcer')
    },
    resetData() {
      document.getElementById('paste-data').value = '';
      this.candidateData = {
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        contact: "",
        jobTitle: "",
        selectedCity: "",
        preferredCities: "",
        ctc: null,
        expectedCTC: null,
        exp: null,
        noticePeriod: null,
        // skillsSelected: "",
        source: "",
        qualification: "",
        dob: "",
        genderSelected: "",
        file: null,
        remarks: ""
      }
      this.error = {
        firstName: '',
        lastName: '',
        email: '',
        contact: '',
        exp: '',
        selectedCity: '',
        preferredCities: '',
        skillsSelected: '',
        qualification: '',
        source: '',
        genderSelected: '',
        dob: '',
        companyName: '',
        jobTitle: '',
        ctc: '',
        expectedCTC: '',
        noticePeriod: '',
        file: '',
        remarks: ''
      }
    },
    formatDate(dateStr) {
      const months = {
        Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
        Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
      };
      
      // Split the date string and destructure it into day, month, and year
      const [day, month, year] = dateStr.split(' ');

      // Zero-pad the day and convert the month string to month number
      const formattedDay = day.length === 1 ? `0${day}` : day;
      const formattedMonth = months[month];

      // Combine the parts into the desired format
      const formattedDate = `${year}-${formattedMonth}-${formattedDay}`;

      return formattedDate;
    },  
    validationForm() {
      // this.submitDisabled = true
      if(!this.candidateData.firstName) {
        this.error.firstName="First Name is Mandatory"
        this.$nextTick(() => {
          this.$refs.firstName.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.lastName) {
        this.error.lastName="Last Name is Mandatory"
        this.$nextTick(() => {
          this.$refs.lastName.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.companyName) {
        this.error.companyName="Company Name is Mandatory, if fresher type  'Fresher'"
        this.$nextTick(() => {
          this.$refs.companyName.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.jobTitle) {
        this.error.jobTitle="Job Title Name is Mandatory, if fresher type 'Fresher'"
        this.$nextTick(() => {
          this.$refs.jobTitle.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      
      
      if(!this.candidateData.email || !this.validateEmail(this.candidateData.email)) {
        
        this.error.email ="Mandatory Field/Email is Invalid"
        this.$nextTick(() => {
          this.$refs.email.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.contact || this.candidateData.contact.length !== 10 || !this.isValidMobileNumber(this.candidateData.contact)) {
        
        if(this.candidateData.contact.length !== 10) {
          this.error.contact="Contact No should be 10 digits"
        } else {
          this.error.contact="Contact No is Mandatory"
        }
        this.$nextTick(() => {
          this.$refs.contact.focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.ctc && String(this.candidateData.source['title']) !== 'LinkedIn') {
        this.error.ctc="CTC is Mandatory, use 0 for freshers"
        this.$nextTick(() => {
          this.$refs.ctc.focus()
        })
        console.log("this") ; this.buttonClicked = false; this.submitStatus = 'Update'
        this.loading = false
        return false
      }
      if(!this.candidateData.exp && this.candidateData.exp !== 0) {
        console.log('exp: ',this.candidate_exp)
        this.error.exp="Experience is Mandatory(if fresher mention 0)"
        this.$nextTick(() => {
          this.$refs.exp.focus()
        })
        this.loading = false
        console.log("this") ; this.buttonClicked = false; this.submitStatus = 'Update'
        return false
      }
      if(!this.candidateData.selectedCity) {
        this.error.selectedCity="City is Mandatory"
        this.$nextTick(() => {
          this.$refs.city.$el.querySelector('input').focus()
        })
        this.loading = false
        console.log("this") ; this.buttonClicked = false; this.submitStatus = 'Update'
        return false
      }
      if(!this.candidateData.qualification) {
        this.error.qualification="Qualification is Mandatory"
        this.$nextTick(() => {
          this.$refs.qualification.$el.querySelector('input').focus()
        })
        this.loading = false
        console.log("this") ; this.buttonClicked = false; this.submitStatus = 'Update'
        return false
      }
      
      if(!this.candidateData.skillsSelected) {
        this.error.skillsSelected="Skills is Mandatory"
        this.$nextTick(() => {
          this.$refs['select-skill'].focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      
      if(!this.candidateData.source) {
        this.error.source="Source is Mandatory"
        this.$nextTick(() => {
          this.$refs.source.$el.querySelector('input').focus()
        })
        console.log("this")
        this.loading = false
        return false
      }
      if(!this.candidateData.genderSelected) {
        this.error.gender="Gender is Mandatory"
        console.log("this")
        this.loading = false
        return false
      }
      // if(!this.candidateData.dob && this.jobInfo.type === 'Contractual') {
      //   this.error.dob="DOB is Mandatory"
      //   console.log("this")
      //   this.loading = false
      //   return false
      // }
      // if(!this.candidateData.dob && this.jobInfo.type === 'Contractual' && this.calculateAge < 18) {
      //   // this.error.dob="DOB is Mandatory"
      //   this.underAge = true
      //   console.log("this")
      //   this.loading = false
      //   return false
      // }
      if(!this.candidateData.file || !this.file) {
        if(this.jobInfo.vertical === 'Infra Industry' && this.jobInfo.category === 'Blue Collar' && this.jobInfo.type === 'Contractual') {
          return true
        }
        this.error.file="Resume/CV is Mandatory"
        console.log("this")
        this.loading = false
        return false
      }
      // if(!this.candidateData.ctc && String(this.candidateData.source['title']) !== 'LinkedIn') {
      //   this.error.ctc="CTC is Mandatory, use 0 for freshers"
      //   this.$nextTick(() => {
      //     this.$refs.ctc.focus()
      //   })
      //   //console.log("this") ; this.buttonClicked = false; this.submitStatus = 'Update'
      //   return false
      // }
      // this.submitDisabled = false
      
      
      this.loading = true
      return true
      
      
    },
    isValidMobileNumber(mobile) {
    // Remove any surrounding whitespace
    const trimmed = mobile.trim();

    // Regex explanation:
    // ^        : start of string
    // [1-9]    : first digit must be between 1 and 9
    // \d{9}    : followed by exactly 9 digits
    // $        : end of string
    const regex = /^[1-9]\d{9}$/;

    return regex.test(trimmed);
  },
    emailNotAvailable() {
      this.candidateData.email = this.candidateData.firstName + this.candidateData.contact + '@sattva.dummy'
    },
    cvNotAvailable() {
      this.cvFile = false
    },
    calculateAge(dobString) {
    // Parse the DOB string (e.g. "1985-07-15") into year, month, and day
      const [year, month, day] = dobString.split("-").map(Number);
      
      // Create a Date object for the DOB
      // Note: JavaScript months are zero-based, so subtract 1 from `month`.
      const dob = new Date(year, month - 1, day);
      
      // Get today's date
      const today = new Date();
      
      // Calculate the rough age
      let age = today.getFullYear() - dob.getFullYear();
      
      // Adjust if the birthday hasn't happened yet this year
      const monthDiff = today.getMonth() - dob.getMonth();
      const dayDiff = today.getDate() - dob.getDate();
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }
      
      return age;
    }

// Example usage:



  },
  mounted(){
    this.jobId = this.$route.params.id;
    console.log('jobid in candidates add ', this.jobId)
    if (this.jobInfo) {
      this.candidateData.skillsSelected = this.jobInfo.position_name;
      // this.formData.email = this.candidateData.email;
      // initialize other form fields...
    }
    // if(this.jobInfo) {
    //   this.jId = this.jobInfo.id
    // }
    console.log('jobInfo: ', this.jobInfo)
    if(this.jobInfo.vertical === 'Infra Industry' && this.jobInfo.category === 'Blue Collar' && this.jobInfo.type === 'Contractual') {
      this.ctcLabel = 'Salary per month *'
    }
    // JobService.getjobInfo(this.jobId).then(res => {
      
    //   this.jobInfo = res.data
    //   this.candidateData.skillsSelected = this.jobInfo.position_name
    //   console.log('job data: ', res.data)
    // })

    // if(this.jobInfo) {
    //   this.jId = this.jobInfo.id
    // }
    // console.log('jobInfo: ', this.jobInfo)
    // if(this.jobInfo.vertical === 'Infra Industry' && this.jobInfo.category === 'Blue Collar' && this.jobInfo.type === 'Contractual') {
    //   this.ctcLabel = 'Salary per month'
    // }
    adminConfigService.getATSDropdownList().then(res => {
        console.log(res.data.data)
        this.sources = res.data.data.sourceList
        this.qualifications = res.data.data.qualificationList
    })
    console.log('skill selected', this.candidateData.skillsSelected, this.jobInfo.position_name);
    JobService.getJobPositionList().then(res => {
      this.skillsOptions = res.data
    })
    locationService.getAll().then(res => {
      console.log(res.data)
      this.cities = res.data
    })
  },
  // updated(){
  //   if(this.candidateData.skillsSelected === '' || this.candidateData.skillsSelected) {
  //     this.candidateData.skillsSelected = [{ "title": this.jobInfo.position_name }]
  //     //console.log('in updated skill selected', this.candidateData.skillsSelected, this.jobInfo.position_name);
  //   } 
  // }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-candidate-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.b-sidebar.sidebar-lg {
  width: 45rem;
  padding-left: 15px;
  padding-right: 15px;
}
.hidden{
  display: none;
}
</style>
